/**
 * @packageDocumentation
 * @module      P_Arm_ECAT3.ts
 * @description Contains Emc related data for Frame
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Arm_ECAT3 {
    constructor() {
        this.X36V = '0';
        this.X5V = '0';
        this.X3V3 = '0';
        this.Temperature = '0';
    }
    static fromJSON(json) {
        if (json) {
            let p_Arm_ECAT3 = new P_Arm_ECAT3();
            if (json.X36V) {
                p_Arm_ECAT3.X36V = toFixedDecimal(json.X36V);
            }
            if (json.X5V) {
                p_Arm_ECAT3.X5V = toFixedDecimal(json.X5V);
            }
            if (json.X3V3) {
                p_Arm_ECAT3.X3V3 = toFixedDecimal(json.X3V3);
            }
            if (json.Temperature) {
                p_Arm_ECAT3.Temperature = toFixedDecimal(json.Temperature);
            }
            return p_Arm_ECAT3;
        }
        return null;
    }
}
//# sourceMappingURL=P_Arm_ECAT3.js.map